import type { Filter } from '@cubejs-client/core'
import { CubeOperator, DRIFT_CHAT_OPPORTUNITY_OVERVIEW } from 'cube'

type GetInfluencedAndSourcedFiltersProps = {
  isInfluenced: boolean
  isSourced: boolean
  initialFilters?: Filter[]
}

/**
 * Function that returns an initialized array of filters for ROI KPIs
 */
export const getInfluencedAndSourcedFilters = ({
  isInfluenced,
  isSourced,
  initialFilters = [],
}: GetInfluencedAndSourcedFiltersProps) => {
  const filtersArray: Filter[] = [...initialFilters]

  if (isInfluenced)
    filtersArray.push({
      member: DRIFT_CHAT_OPPORTUNITY_OVERVIEW.IS_INFLUENCED,
      operator: CubeOperator.EQUALS,
      values: [isInfluenced ? 'true' : 'false'],
    })

  if (isSourced)
    filtersArray.push({
      member: DRIFT_CHAT_OPPORTUNITY_OVERVIEW.IS_SOURCED,
      operator: CubeOperator.EQUALS,
      values: [isSourced ? 'true' : 'false'],
    })

  return filtersArray
}
